import React from "react";

export const CollapseIcon: React.FC<VideoIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3746 12.0863V7.9163C13.3746 7.74325 13.298 7.6247 13.1446 7.56068C12.9913 7.49651 12.8532 7.52589 12.7305 7.6488L10.9051 9.47401C10.7545 9.62471 10.6792 9.80047 10.6792 10.0013C10.6792 10.2021 10.7545 10.3779 10.9051 10.5286L12.7305 12.3538C12.8532 12.4767 12.9913 12.5061 13.1446 12.4419C13.298 12.3779 13.3746 12.2594 13.3746 12.0863ZM4.42443 17.0846C4.00887 17.0846 3.65387 16.9375 3.35943 16.6432C3.06512 16.3487 2.91797 15.9937 2.91797 15.5782V4.42443C2.91797 4.00887 3.06512 3.65387 3.35943 3.35943C3.65387 3.06512 4.00887 2.91797 4.42443 2.91797H15.5782C15.9937 2.91797 16.3487 3.06512 16.6432 3.35943C16.9375 3.65387 17.0846 4.00887 17.0846 4.42443V15.5782C17.0846 15.9937 16.9375 16.3487 16.6432 16.6432C16.3487 16.9375 15.9937 17.0846 15.5782 17.0846H4.42443ZM6.66797 15.8346V4.16797H4.42443C4.36026 4.16797 4.30151 4.1947 4.24818 4.24818C4.19471 4.30151 4.16797 4.36026 4.16797 4.42443V15.5782C4.16797 15.6423 4.19471 15.7011 4.24818 15.7544C4.30151 15.8079 4.36026 15.8346 4.42443 15.8346H6.66797ZM7.91797 15.8346H15.5782C15.6423 15.8346 15.7011 15.8079 15.7544 15.7544C15.8079 15.7011 15.8346 15.6423 15.8346 15.5782V4.42443C15.8346 4.36026 15.8079 4.30151 15.7544 4.24818C15.7011 4.1947 15.6423 4.16797 15.5782 4.16797H7.91797V15.8346Z"
        fill="#1C00B8"
      />
    </svg>
  );
};
